<template>
  <div>


    <v-card class="shadow rounded-lg">

      <v-overlay :value="overlay"
                 absolute
                 color="white"
                 opacity="0.5">
        <v-progress-circular
            indeterminate
            size="50"
            color="primary"
        ></v-progress-circular>
      </v-overlay>

      <v-card-title>

        <div>
          <v-text-field
              v-model="keyword"
              append-icon="mdi-magnify"
              hint="Tapez et appuyez sur Entrée pour rechercher"
              clearable
              dense
              filled
              persistent-hint
              placeholder="Recherche..."
              rounded
              @keyup.enter="() => {}"
          />
        </div>

        <v-spacer/>

        <v-btn color="grey"
               class="rounded-lg mr-2"
               text
               @click=getItems>
          <v-icon left>mdi-refresh</v-icon>
          Mettre à jour
        </v-btn>

        <v-btn @click="add"
               class="rounded-lg"
               depressed
               color="gifty"
               dark>
          <v-icon left>mdi-plus</v-icon>
          Ajouter
        </v-btn>

      </v-card-title>

      <v-divider/>

      <v-card-text v-if="isLoading">
        <v-skeleton-loader type="table"/>
      </v-card-text>

      <div v-else>

        <v-card-text class="pa-0">

          <v-simple-table v-if="filteredItems.length">
            <template v-slot:default>
              <thead>
              <tr>
                <th>Actif / Inactif</th>
                <th>Nom</th>
                <th>Description</th>
                <th>Type</th>
                <th>Créé le</th>
                <th>Action</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item,i) in filteredItems" :key="i">
                <td>
                  <v-chip
                      small
                      :color="item.is_active ? 'green' : 'red'"
                      text-color="white"
                  >
                    <v-icon left small>
                      {{ item.is_active ? 'mdi-check' : 'mdi-close' }}
                    </v-icon>

                    {{ item.is_active ? 'Actif' : 'Inactif' }}
                  </v-chip>
                </td>
                <td>{{ item.name?.fr }}</td>
                <td>{{ item.description?.fr }}</td>
                <td>
                  <v-chip
                      small
                      :color="item.type === 'amount' ? 'indigo' : 'purple'"
                      text-color="white"
                  >
                    <v-icon left small>
                      {{ item.type === 'amount' ? 'mdi-cash' : 'mdi-counter' }}
                    </v-icon>

                    {{ getTypeLabel(item.type) }}
                  </v-chip>
                </td>
                <td>
                  {{ formatDate(item.created_at) }}
                </td>
                <td>
                  <v-btn color="gifty" icon @click="update(item)">
                    <v-icon>mdi-pencil-outline</v-icon>
                  </v-btn>
                  <v-btn disabled color="gifty" icon @click="remove(item.id)">
                    <v-icon>mdi-delete-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>

          <div v-else>
            <NoResults @reload="getItems"/>
          </div>

        </v-card-text>

      </div>

    </v-card>

    <FormDialog ref="formDialog" @refresh="getItems"/>

  </div>
</template>

<script>
import {HTTP} from "@/http-common";
import NoResults from "@/components/NoResults";
import FormDialog from "./FormDialog";

export default {
  components: {FormDialog, NoResults},
  data() {
    return {
      keyword: "",
      isLoading: false,
      overlay: false,
      id: null,
      items: []
    };
  },
  methods: {
    getTypeLabel(type) {
      const types = {
        amount: 'Montant',
        quantity: 'Quantité',
      };

      return types[type] || type;
    },
    formatDate(date) {
      if (!date) return '-';

      return new Date(date).toLocaleDateString('fr-FR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    getItems() {
      this.isLoading = true
      HTTP.get('/v1/opus/objectives').then(res => {
        this.isLoading = false
        this.items = res.data.data
      }).catch(err => {
        this.isLoading = false
        console.log(err)
      })
    },
    add() {
      this.$refs.formDialog.open()
    },
    update(item) {
      this.$refs.formDialog.open(item)
    },
    remove(id) {
      this.id = id
      this.$confirm_dialog = true
    },
    deleteItem() {
      this.overlay = true
      HTTP.delete(`/v1/opus/objectives/${this.id}`).then(() => {
        this.overlay = false
        this.items = this.items.filter(el => el.id !== this.id);
        this.id = null;
      }).catch(err => {
        this.overlay = false
        console.log(err)
      })
    }
  },
  created() {
    this.getItems();
  },
  watch: {
    $is_confirm: function (el) {
      if (el) {
        this.deleteItem()
        this.$is_confirm = false
      }
    },
  },
  computed: {
    filteredItems() {
      if (!this.keyword) return this.items;
      const k = this.keyword.toLowerCase();
      return this.items.filter(item => {
        return (
            (item.name?.fr || "").toLowerCase().includes(k) ||
            (item.description?.fr || "").toLowerCase().includes(k) ||
            (item.type || "").toLowerCase().includes(k)
        );
      });
    }
  }
};
</script>

<style scoped></style>
